<template>
  <div class="mt-4  px-5">

    <h2>Schiessbuch</h2>

    <v-alert dense type="info">
      <b>Tipp:</b>
      <div class="">Hier werden alle beendeten Einträge von dir angezeigt. <br>
        Möchtest du von deinem Verein, ein Training bestätigt bekommen, so klicke auf <i
            class="fas fa-hands-helping"></i> "bestätigen". <br>
        <br><i class="fas fa-user-graduate"></i> Dein Schuetzenbuch kannst du exportieren, falls du es mal bei einem
        Amt vorlegen möchtest.
      </div>
    </v-alert>

    <OpenShootingBookEntry/>

    <v-data-table
        :headers="headers"
        :items="comp_filteredShootingbook"
        :sort-by="['created_at']"
        :sort-desc="[true]"
        class="elevation-1 mt-8"
        ref="myShootingbook"
        :item-class="itemRowClass"
        :loading="comp_Progress_loading"
        loader-height="5"
    >
      <template v-slot:top>
        <v-toolbar flat dense color="success" dark>
          <v-toolbar-title>Schiessbuch</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-switch
              v-model="export_all"
              :label="export_all ? 'Export: Alle' : 'Export: Gefiltert'"
              dense
              hide-details
              class="mt-0 mr-2"
          ></v-switch>
          <shootingbook-p-d-f-export
              :pdf_data="comp_exportData"
              :name="comp_Name"
              club_user="user">
          </shootingbook-p-d-f-export>
          <shootingbook-excel-export
              :excel_data="comp_exportData"
              :name="comp_Name"
              club_user="user">
          </shootingbook-excel-export>
          <v-btn icon @click="getMyShootingbook">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar>

        <div style="padding: 12px 16px; border-bottom: 1px solid rgba(0,0,0,.12);">
          <v-row dense align="center">
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                  v-model="search"
                  label="Suche (Verein, Waffe, Stand, ...)"
                  prepend-inner-icon="mdi-magnify"
                  outlined dense clearable hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-select
                  v-model="filter_status"
                  :items="statusOptions"
                  label="Status"
                  outlined dense hide-details clearable
              ></v-select>
            </v-col>
            <v-col cols="6" sm="3" md="2">
              <v-text-field
                  v-model="date_from"
                  label="Von"
                  type="date"
                  outlined dense hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3" md="2">
              <v-text-field
                  v-model="date_to"
                  label="Bis"
                  type="date"
                  outlined dense hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="auto" class="d-flex align-center">
              <v-btn text small @click="resetFilters">
                <v-icon left small>mdi-filter-off</v-icon>
                Zurücksetzen
              </v-btn>
              <span class="caption grey--text ml-2">
                {{ comp_filteredShootingbook.length }}/{{ comp_myShootingbook.length }}
              </span>
            </v-col>
          </v-row>
        </div>
      </template>

      <template v-slot:item.KurzT="{ item }">
        {{ item.KurzT }}
        <v-tooltip v-if="item.is_from_pool" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-chip
              v-bind="attrs"
              v-on="on"
              x-small
              color="info"
              class="ml-1"
            >
              🎯 Pool
            </v-chip>
          </template>
          <span>Vereinswaffe von {{ item.verein_name || 'Verein' }}</span>
        </v-tooltip>
      </template>

      <template v-slot:item.shooting_function_name="{ item }">
        <span>{{ item.shooting_function_name || item.Aufsicht || item.funktion_name || (isNaN(item.funktion) ? item.funktion : getFunctionName(item.shooting_function_id || item.funktion)) }}</span>
      </template>

      <template v-slot:item.beginn="{ item }">
        <span v-if="item.club_id !=null">{{
            new Date(item.beginn.replace(" ", "T")).toLocaleString([], {dateStyle: 'short', timeStyle: 'short'})
          }}</span>
        <span v-else>{{
            new Date(item.beginn.replace(" ", "T")).toLocaleString([], {dateStyle: 'short'})
          }}</span>
      </template>
      <template v-slot:item.ende="{ item }">
        <span v-if="item.club_id !=null">{{
            new Date(item.ende.replace(" ", "T")).toLocaleString([], {dateStyle: 'short', timeStyle: 'short'})
          }}</span>
        <span v-else>{{
            new Date(item.beginn.replace(" ", "T")).toLocaleString([], {dateStyle: 'short'})
          }}</span>
      </template>

      <template v-slot:item.approval="{ item }">
        <!-- Status 1: eingereicht → zurücknehmen -->
        <v-btn
            v-if="item.bestaetigung_status === 1 && item.club_id != null"
            color="warning"
            width="180px"
            @click="send_to_confirmation(item)"
        >
          <v-icon class="mr-2" x-small>fas fa-thumbtack</v-icon>
          zurücknehmen
        </v-btn>

        <!-- Status 0: nicht eingereicht → einreichen -->
        <v-btn
            v-if="item.bestaetigung_status === 0 && item.club_id != null"
            color="info"
            width="180px"
            @click="send_to_confirmation(item)"
        >
          <v-icon class="mr-2" x-small>fas fa-hands-helping</v-icon>
          bestätigen
        </v-btn>

        <!-- Status 3: abgelehnt → Grund anzeigen + neu einreichen -->
        <div v-if="item.bestaetigung_status === 3 && item.club_id != null">
          <div v-if="item.abgelehnt_grund" class="error--text caption mb-1">
            <v-icon x-small color="error">mdi-alert-circle</v-icon>
            {{ item.abgelehnt_grund }}
          </div>
          <v-btn
              color="error"
              width="180px"
              @click="send_to_confirmation(item)"
          >
            <v-icon class="mr-2" x-small>fas fa-redo</v-icon>
            Neu einreichen
          </v-btn>
        </div>

        <!-- Externe Einträge (ohne Verein) -->
        <shootingbook-sign-entry
            v-show="item.bestaetigt_vereinDatum === null"
            v-if="item.bestaetigung_status === 0 && item.club_id === null"
            :item="item">
        </shootingbook-sign-entry>

        <shootingbook-show-signature
            v-show="item.bestaetigt_vereinDatum != null && item.club_id === null"
            :item="item"
        ></shootingbook-show-signature>
      </template>

      <template v-slot:item.approvaldate="{ item }">

            <span v-if="item.bestaetigt_vereinDatum !== null">
             <span>
               Freigegeben am: <br>
               {{
                 new Date(item.bestaetigt_vereinDatum.replace(" ", "T")).toLocaleString([], {
                   dateStyle: 'short',
                   timeStyle: 'short'
                 })
               }}
             </span>
            </span>

      </template>

      <template v-slot:item.action="{ item }">
        <div class="d-flex justify-center">
          <v-btn
              v-if="item.bestaetigung_status !== 2"
              icon
              color="info"
              @click="openEditDialog(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
              v-if="item.bestaetigung_status === 0"
              icon
              color="error"
              @click="delShootingBookEntry_Dialog(item)"
          >
            <v-icon>mdi-trash-can</v-icon>
          </v-btn>
        </div>
      </template>

      <template v-slot:no-data>
        <v-btn
            color="primary"
            @click="initialize"
        >
          neu laden
        </v-btn>
      </template>
    </v-data-table>

    <!-- Edit Dialog -->
    <v-dialog v-model="dialogEdit" max-width="800" :retain-focus="false">
      <v-card>
        <v-card-title class="text-h5">Eintrag ändern</v-card-title>
        <v-card-text>
          <v-container fluid class="pa-2 pa-sm-4">
            <v-card outlined class="mb-4">
              <v-card-subtitle class="pb-2">Standort</v-card-subtitle>
              <v-card-text>
                <v-text-field label="Verein" v-model="editItem.Club" outlined dense hide-details="auto" class="mb-3" readonly disabled></v-text-field>
                <v-text-field label="Stand" v-model="editItem.ClubRange" outlined dense hide-details="auto" class="mb-3" readonly disabled></v-text-field>
                <v-text-field label="Bahn" v-model="editItem.Place" outlined dense hide-details="auto" readonly disabled></v-text-field>
              </v-card-text>
            </v-card>

            <v-card outlined class="mb-4">
              <v-card-subtitle class="pb-2">Aktivität & Funktion</v-card-subtitle>
              <v-card-text>
                <v-text-field label="Funktion" v-model="editItem.shootingActionText" outlined dense hide-details="auto" class="mb-3" readonly disabled></v-text-field>
                <v-text-field label="Aktivität" v-model="editItem.aktivitaet" outlined dense hide-details="auto" readonly disabled></v-text-field>
              </v-card-text>
            </v-card>

            <v-card outlined class="mb-4">
              <v-card-subtitle class="pb-2">Waffe & Zeitpunkt</v-card-subtitle>
              <v-card-text>
                <v-text-field label="Waffe" v-model="editItem.OwnWeapon" outlined dense hide-details="auto" class="mb-3" readonly disabled></v-text-field>
                <v-dialog
                    v-if="editItem.IsExternal"
                    v-model="editDateMenu"
                    width="290px"
                    :retain-focus="false"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        :value="comp_editBeginDateFormatted"
                        label="Datum"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        dense
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                      v-model="editItem.BeginDate"
                      locale="de"
                      :first-day-of-week="1"
                      scrollable
                      @input="editDateMenu = false"
                  ></v-date-picker>
                </v-dialog>
                <template v-else>
                  <div class="mb-3">
                    <v-datetime-picker
                        label="Beginn"
                        date-format="dd.MM.yyyy"
                        time-format="HH:mm"
                        v-model="editItem.Begin"
                        :retain-focus="false"
                        :text-field-props="editDatetimeFieldProps"
                        :time-picker-props="{ format: '24hr' }"
                    >
                      <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                      <template slot="timeIcon"><v-icon>mdi-clock-outline</v-icon></template>
                    </v-datetime-picker>
                  </div>
                  <v-datetime-picker
                      label="Ende"
                      date-format="dd.MM.yyyy"
                      time-format="HH:mm"
                      v-model="editItem.Ende"
                      :retain-focus="false"
                      :text-field-props="editDatetimeFieldProps"
                      :time-picker-props="{ format: '24hr' }"
                  >
                    <template slot="dateIcon"><v-icon>mdi-calendar</v-icon></template>
                    <template slot="timeIcon"><v-icon>mdi-clock-outline</v-icon></template>
                  </v-datetime-picker>
                </template>
              </v-card-text>
            </v-card>

            <v-card outlined class="mb-4">
              <v-card-subtitle class="pb-2">Ergebnis erfassen</v-card-subtitle>
              <v-card-text>
                <v-text-field label="Schuss" v-model="editItem.AnzSchuss" outlined dense hide-details="auto" class="mb-3" type="number" min="1" max="5000"></v-text-field>
                <v-text-field label="Ergebnis" v-model="editItem.Summe" outlined dense hide-details="auto"></v-text-field>
              </v-card-text>
            </v-card>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-4 py-3">
          <v-btn color="grey darken-1" text @click="dialogEdit = false">Abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" large @click="saveEdit()">
            <v-icon left>far fa-save</v-icon>
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">Willst du diesen Eintrag wirklich löschen?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false; prepare_delete_item = {}">Abbrechen</v-btn>
          <v-btn color="blue darken-1" text @click="delShootingBooKEntry()">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import shootingbookExcelExport from '@/views/component/shootingbookExcelExport';
import shootingbookPDFExport from '@/views/component/shootingbookPDFExport';
import shootingbookShowSignature from "@/views/component/shootingbookShowSignature.vue";
import shootingbookSignEntry from "@/views/component/shootingbookSignEntry.vue";
import OpenShootingBookEntry from "@/views/component/OpenShootingBookEntry.vue";

const today = new Date();
const defaultFrom = new Date(today.getFullYear(), 0, 1).toISOString().split('T')[0];
const defaultTo   = today.toISOString().split('T')[0];

export default {
  name: "shootingbook",
  components: {
    shootingbookExcelExport, shootingbookPDFExport, shootingbookShowSignature, shootingbookSignEntry, OpenShootingBookEntry
  },
  data: () => ({
    dialog: false,
    dialogDelete: false,
    dialogSign: false,
    loading: false,
    search: '',
    filter_status: null,
    date_from: defaultFrom,
    date_to: defaultTo,
    export_all: false,
    statusOptions: [
      { text: 'Nicht eingereicht', value: 0 },
      { text: 'Eingereicht',       value: 1 },
      { text: 'Freigegeben',       value: 2 },
      { text: 'Abgelehnt',         value: 3 },
    ],
    headers: [
      {
        align: 'Vereinsnummer',
        sortable: false,
      },
      {text: 'Verein', value: 'comp_vereinname'},
      {text: 'Aktivität', value: 'aktivitaet'},
      {text: 'Stand', value: 'KurzBez'},
      {text: 'Bahn', value: 'bahn'},
      {text: 'Funktion', value: 'shooting_function_name'},
      {text: 'Waffe - Kurztext', value: 'KurzT'},
      {text: 'Begin', value: 'beginn'},
      {text: 'Ende', value: 'ende'},
      {text: 'Disziplin', value: 'LangBez'},
      {text: 'Schuss', value: 'tr_schuss'},
      {text: 'Ergebnis', value: 'trergges'},
      {text: 'Verein freigabe', value: 'approval', sortable: false, align: 'center'},
      {text: 'Freigabe', value: 'approvaldate', sortable: false},
      {text: 'Action', value: 'action', sortable: false, align: 'center'},
    ],

    editedItem: {},
    signature_style: {border: 'black 3px solid'},
    prepare_delete_item: {},
    dialogEdit: false,
    editItem: {
      SB_EDIT_ID: null,
      Club: null,
      ClubRange: null,
      Place: null,
      shootingActionText: null,
      aktivitaet: null,
      OwnWeapon: null,
      Begin: new Date(),
      Ende: new Date(),
      BeginDate: null,
      IsExternal: false,
      AnzSchuss: null,
      Summe: null,
    },
    editDatetimeFieldProps: { outlined: true, dense: true, hideDetails: 'auto', class: 'mb-0' },
    editDateMenu: false,
  }),

  computed: {
    comp_myShootingbook() {
      return this.$store.state.UserApp.MyShootingbook;
    },
    comp_filteredShootingbook() {
      let data = this.comp_myShootingbook;

      if (this.search && this.search.trim()) {
        const s = this.search.toLowerCase().trim();
        data = data.filter(item =>
          (item.comp_vereinname        && item.comp_vereinname.toLowerCase().includes(s)) ||
          (item.aktivitaet             && item.aktivitaet.toLowerCase().includes(s)) ||
          (item.KurzBez                && item.KurzBez.toLowerCase().includes(s)) ||
          (item.KurzT                  && item.KurzT.toLowerCase().includes(s)) ||
          (item.LangBez                && item.LangBez.toLowerCase().includes(s)) ||
          (item.shooting_function_name && item.shooting_function_name.toLowerCase().includes(s)) ||
          (item.funktion_name          && item.funktion_name.toLowerCase().includes(s))
        );
      }

      if (this.filter_status !== null && this.filter_status !== undefined) {
        data = data.filter(item => item.bestaetigung_status === this.filter_status);
      }

      if (this.date_from) {
        const from = new Date(this.date_from + 'T00:00:00');
        data = data.filter(item => new Date(item.beginn.replace(' ', 'T')) >= from);
      }

      if (this.date_to) {
        const to = new Date(this.date_to + 'T23:59:59');
        data = data.filter(item => new Date(item.beginn.replace(' ', 'T')) <= to);
      }

      return data;
    },
    comp_exportData() {
      return this.export_all ? this.comp_myShootingbook : this.comp_filteredShootingbook;
    },
    comp_Progress_loading() {
      return this.$store.getters['UserApp/is_loading_shootingbook'];
    },
    comp_Name() {
      return this.$store.getters['UserAuth/isUserName'];
    },
    comp_editBeginDateFormatted() {
      if (!this.editItem.BeginDate) return '';
      const [y, m, d] = this.editItem.BeginDate.split('-');
      return `${d}.${m}.${y}`;
    },

  },

  // Beim Öffnen immer frisch laden, sonst fehlt z. B. ein gerade am Terminal
  // erfasster Eintrag
  created() {
    this.getMyShootingbook();
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
    dialogDelete(val) {
      val || this.closeDelete()
    },
  },

  methods: {
    getMyShootingbook() {
      this.$store.dispatch('UserApp/getMyShootingbook')
    },

    getFunctionName(id) {
      const map = { 1: "Schütze", 2: "Standaufsicht", 3: "Schießsportleiter" };
      return map[id] || "Unbekannt";
    },

    resetFilters() {
      this.search = '';
      this.filter_status = null;
      this.date_from = defaultFrom;
      this.date_to = defaultTo;
    },

    send_to_confirmation(item) {
      this.$store.commit('UserApp/SET_SHOOTINGBOOK_LOADER', true);

      const Data = {
        freigabeID: item.id,
        freigabebool: item.bestaetigung_status !== 1,
      };

      this.$store.dispatch('UserApp/send_ShootingBookRecord_to_confirmation', Data)
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },
    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    }
    ,
    itemRowClass(item) {
      if (item.bestaetigung_status === 2) {
        return 'green lighten-4';
      } else if (item.bestaetigung_status === 1) {
        return 'amber lighten-4';
      } else if (item.bestaetigung_status === 3) {
        return 'red lighten-5';
      }
      return '';
    },

    initialize() {
      this.$store.dispatch('UserApp/getMyShootingbook')
    },

    delShootingBookEntry_Dialog(item) {
      this.dialogDelete = true;
      this.prepare_delete_item = Object.assign({}, item)
    },

    delShootingBooKEntry() {
      const Data = {
        'shootingbook_id': this.prepare_delete_item.id
      }

      this.$store.dispatch('UserApp/delShootingbookEntry', Data)
          .then(this.dialogDelete = false,
              this.prepare_delete_item = {}
          )
    },

    openEditDialog(item) {
      const funktionText = item.shooting_function_name || item.Aufsicht || item.funktion_name;
      const beginDate = new Date(item.beginn.replace(' ', 'T'));
      this.editItem.SB_EDIT_ID = item.id;
      this.editItem.Club = item.comp_vereinname || item.name;
      this.editItem.ClubRange = item.KurzBez;
      this.editItem.Place = item.bahn;
      this.editItem.shootingActionText = funktionText;
      this.editItem.aktivitaet = item.aktivitaet;
      this.editItem.OwnWeapon = item.KurzT;
      this.editItem.Begin = beginDate;
      this.editItem.Ende = new Date(item.ende.replace(' ', 'T'));
      this.editItem.IsExternal = item.club_id == null;
      this.editItem.BeginDate = this.formatDateInput(beginDate);
      this.editItem.AnzSchuss = item.tr_schuss;
      this.editItem.Summe = item.trergges;
      this.dialogEdit = true;
    },

    formatDateInput(d) {
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },

    saveEdit() {
      let begin = this.editItem.Begin;
      let ende = this.editItem.Ende;
      if (this.editItem.IsExternal && this.editItem.BeginDate) {
        const [y, m, d] = this.editItem.BeginDate.split('-').map(Number);
        const dt = new Date(y, m - 1, d, 0, 0, 0);
        begin = dt;
        ende = dt;
      }
      const Data = {
        offeneEditID: this.editItem.SB_EDIT_ID,
        inputEditoffeneBeginn: begin,
        inputEditoffeneEnde: ende,
        inputSchuss: this.editItem.AnzSchuss,
        inputEditoffeneTrErgGesamt: this.editItem.Summe,
      };
      this.$store.dispatch('UserApp/updateNewShootingBookRecord', Data)
          .then(() => { this.dialogEdit = false; });
    },

  },

}

</script>

<style scoped>


</style>
